import { render, staticRenderFns } from "./monthly-calendar.vue?vue&type=template&id=966759ec&scoped=true&"
import script from "./monthly-calendar.vue?vue&type=script&lang=ts&"
export * from "./monthly-calendar.vue?vue&type=script&lang=ts&"
import style0 from "./monthly-calendar.vue?vue&type=style&index=0&id=966759ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966759ec",
  null
  
)

export default component.exports